import { z } from 'zod';

/**
 * Choosing the one active provider of a capability.
 *
 * The provider must exist in the catalog and be `wired` — both checked on the
 * server, where the catalog lives (422). Activation is a switch, not a toggle:
 * activating B deactivates A by construction, because the capability row is
 * unique.
 */
export const ActivateIntegrationProviderSchema = z.object({ provider: z.string().min(1) }).strict();

export type ActivateIntegrationProviderRequest = z.infer<typeof ActivateIntegrationProviderSchema>;
